var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EDocumentMemberTypes, } from "@rentiohq/shared/dist/types/document.types";
import { appendFilter } from "@rentiohq/shared/dist/utils/api.utils";
import { appendQueryParams } from "@rentiohq/shared/dist/utils/url.utils";
import axios from "axios";
import merge from "lodash/merge";
import { Platform } from "react-native";
import api from "../../utils/api/api.utils";
import { guessExtensionFromPathAndMime } from "./document.utils";
export var FETCH_LIMIT = 20;
export var addDocumentMembers = function (documentId, accountIds) {
    return api.post("/documents/" + documentId + "/members", {
        data: accountIds.map(function (accountId) { return ({
            accountId: accountId,
            roles: [EDocumentMemberTypes.Viewer],
        }); }),
    });
};
export var deleteDocumentMembers = function (documentId, accountIds) {
    return api.delete("/documents/" + documentId + "/members", {
        data: accountIds.map(function (accountId) { return ({
            accountId: accountId,
            roles: [EDocumentMemberTypes.Viewer],
        }); }),
    });
};
export var getDocuments = function (skip, extraFilterData, limit) {
    if (extraFilterData === void 0) { extraFilterData = {}; }
    if (limit === void 0) { limit = FETCH_LIMIT; }
    var filter = merge({}, extraFilterData, {
        order: "createdAt DESC",
        limit: limit,
        skip: skip,
    });
    return api.get(appendFilter("/documents", filter));
};
export var getContactDocuments = function (contactId, skip, extraFilterData, limit) {
    if (extraFilterData === void 0) { extraFilterData = {}; }
    if (limit === void 0) { limit = FETCH_LIMIT; }
    var filter = {
        order: "createdAt DESC",
        limit: limit,
        skip: skip,
        where: merge({}, extraFilterData),
    };
    return api.get(appendFilter("/contacts/" + contactId + "/documents", filter));
};
export var getDocument = function (documentId, extraQueryParams) {
    return api.get(appendQueryParams({
        path: "/documents/" + documentId,
        queryParams: extraQueryParams || {},
    }));
};
export var updateDocument = function (documentId, data) { return api.put("/documents/" + documentId, { data: data }); };
export var deleteDocument = function (documentId) {
    return api.delete("/documents/" + documentId);
};
export var getPresignedUrl = function (extension) {
    return api.post("/documents/pre-signed-urls", {
        data: {
            extension: extension,
        },
    });
};
export var uploadDocument = function (presignedUrl, metaData, path) {
    return api.post(path || "/documents", {
        data: {
            preSignedUrl: presignedUrl,
            meta: metaData,
        },
    });
};
export var uploadDocumentToS3 = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var extension, data, presignedUrl, formData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                extension = guessExtensionFromPathAndMime(file.path, file.type);
                return [4 /*yield*/, getPresignedUrl(extension)];
            case 1:
                data = (_a.sent()).data;
                presignedUrl = data.preSignedUrl;
                formData = new FormData();
                Object.keys(presignedUrl.fields).forEach(function (fieldName) {
                    formData.append(fieldName, presignedUrl.fields[fieldName]);
                });
                if (Platform.OS === "web") {
                    // @ts-ignore
                    formData.append("File", file);
                }
                else {
                    // @ts-ignore
                    formData.append("File", __assign({ name: "file", uri: file.path }, file));
                }
                return [4 /*yield*/, axios.post(presignedUrl.url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/, presignedUrl];
        }
    });
}); };
export var getDocumentCategories = function () {
    return api.get("/documents/categories");
};
